var map = {
	"./Logo_Sorbonne_Université.png": 120,
	"./NoLogo.png": 121,
	"./Universite-Paris-Saclay.png": 122,
	"./Zindi_Logo.png": 123,
	"./abacusai_logo.jpg": 124,
	"./abacusai_logo.png": 125,
	"./address_image.svg": 126,
	"./animated_ashutosh.png": 127,
	"./animated_logo.svg": 128,
	"./asr.png": 129,
	"./asr_zindi.png": 130,
	"./birdcall.png": 131,
	"./blogs_image.svg": 132,
	"./cassava.png": 133,
	"./cloud_infrastructure.svg": 134,
	"./codeInLogo.png": 135,
	"./constraint.png": 136,
	"./contact-modified.png": 137,
	"./contactMail.png": 138,
	"./cosmetics defects.png": 139,
	"./coursera_logo.png": 140,
	"./crisp-thinking-logo_updated-v2.png": 141,
	"./crisp.png": 142,
	"./data_science.svg": 143,
	"./deeplearning_ai_logo.png": 144,
	"./defects.jpg": 145,
	"./delhivery_logo.png": 146,
	"./developerActivity.svg": 147,
	"./dsc_logo.png": 148,
	"./education.svg": 149,
	"./essilorluxoticca.jpg": 150,
	"./essilorluxoticca.png": 151,
	"./experience.svg": 152,
	"./feelingProud.svg": 153,
	"./freecopy_logo.png": 154,
	"./fullstack.svg": 155,
	"./gcp_logo.png": 156,
	"./github_logo.png": 157,
	"./googleAssistant.jpg": 158,
	"./googleAssistant.svg": 159,
	"./google_logo.png": 160,
	"./hf.png": 161,
	"./hf2.png": 162,
	"./ibm_logo.png": 163,
	"./iiitk_logo.png": 164,
	"./intel_logo.jpg": 165,
	"./iu_logo.png": 166,
	"./jsFramework.svg": 167,
	"./kaggle.png": 168,
	"./legato_logo.png": 169,
	"./logically.jpg": 170,
	"./logically.png": 171,
	"./manOnTable.svg": 172,
	"./microsoft.png": 173,
	"./microsoft_logo.png": 174,
	"./movie_genre.jpg": 175,
	"./mozilla_logo.png": 176,
	"./muffito_logo.png": 177,
	"./nextuLogo.jpg": 178,
	"./nptel_logo.png": 179,
	"./ocr.png": 180,
	"./pix2pix.png": 181,
	"./polytech_sorbonne.jpg": 182,
	"./polytech_sorbonne.png": 183,
	"./portfolio.gif": 184,
	"./programmer.svg": 185,
	"./projects_image.svg": 186,
	"./pwa.png": 187,
	"./saayaHealthLogo.png": 188,
	"./stanford_logo.png": 189,
	"./talksCardBack.svg": 190,
	"./talksCardBackAlt.svg": 191,
	"./tiktok_logo.png": 192,
	"./ucdavis.avif": 193,
	"./ui_ux_design.svg": 194,
	"./wassa.png": 195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;